/**
 * TopologyDefinitions.js
 * Defines the Minimum Viable Topology (MVT) for various musical sections.
 * Used by the Orchestrator to ensure critical roles are always present,
 * preventing "Under-Populated" sections even if tension is low.
 */

export const MINIMUM_VIABLE_TOPOLOGY = {
    // High Energy / Transition
    BUILD: {
        minCountRatio: 0.5, // Start with at least 50% of ensemble
        requiredRoles: ['riser', 'percussion', 'pad', 'rhythm'] // Generic requirements
    },
    DROP: {
        minCountRatio: 0.8, // Start nearly full
        requiredRoles: ['kick', 'bass', 'lead', 'percussion']
    },
    CLIMAX: {
        minCountRatio: 0.7,
        requiredRoles: ['melody', 'bass', 'percussion', 'harmony']
    },

    // Standard Song Structure
    VERSE: {
        minCountRatio: 0.2,
        requiredRoles: ['bass', 'harmony'] // Minimal backbone
    },
    CHORUS: {
        minCountRatio: 0.5,
        requiredRoles: ['bass', 'percussion', 'harmony', 'melody']
    },
    INTRO: {
        minCountRatio: 0.1,
        requiredRoles: ['harmony'] // Can be just a pad/piano
    },
    OUTRO: {
        minCountRatio: 0.1,
        requiredRoles: ['harmony']
    },

    // Specific Vibe
    BREAK: {
        minCountRatio: 0.2,
        requiredRoles: ['percussion'] // Drum break
    }
};

/**
 * Keyword mapping to abstract roles or instrument IDs.
 * Used to match 'requiredRoles' string to actual Instrument Objects.
 */
export const ROLE_KEYWORDS = {
    'riser': ['fx', 'riser', 'sweep', 'transition'],
    'kick': ['kick', 'drum_kick'],
    'snare': ['snare', 'drum_snare'],
    'bass': ['bass', 'sub', 'low'],
    'lead': ['lead', 'solo', 'melody'],
    'pad': ['pad', 'strings', 'atmosphere'],
    'rhythm': ['plucked', 'guitar', 'keys', 'shaker', 'hat'],
    'percussion': ['drum', 'perc', 'timpani', 'cymbals'],
    'harmony': ['piano', 'guitar', 'strings', 'pad', 'keys'],
    'melody': ['lead', 'violin', 'flute', 'synth_lead', 'piano']
};
